import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlPaymentOrderBankInfoRequest } from "../models/service-models/paymentOrder/PaymentOrderBankInfoRequest";
import { mdlPaymentOrderBankInfoResponse } from "../models/service-models/paymentOrder/PaymentOrderBankInfoResponse";
import { mdlPaymentOrderCreateRequest } from "../models/service-models/paymentOrder/PaymentOrderCreateRequest";
import { mdlPaymentOrderCreateResponse } from "../models/service-models/paymentOrder/PaymentOrderCreateResponse";
import { mdlPaymentOrderDetailRequest } from "../models/service-models/paymentOrder/PaymentOrderDetailRequest";
import { mdlPaymentOrderDetailResponse } from "../models/service-models/paymentOrder/PaymentOrderDetailResponse";
import { GetResponse } from "../utils/ApiClient";

namespace PaymentOrderService {
    export async function CreatePaymentOrder(
        pRequest: mdlPaymentOrderCreateRequest
    ): Promise<mdlServiceResponse<mdlPaymentOrderCreateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlPaymentOrderCreateResponse>>(
            "paymentOrder/createPaymentOrder",
            pRequest
        );
    }

    export async function GetPaymentOrderDetail(
        pRequest: mdlPaymentOrderDetailRequest
    ): Promise<mdlServiceResponse<mdlPaymentOrderDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlPaymentOrderDetailResponse>>(
            "paymentOrder/getPaymentOrderDetail",
            pRequest
        );
    }

    export async function GetPaymentOrderBankInfo(
        pRequest: mdlPaymentOrderBankInfoRequest
    ) : Promise<mdlServiceResponse<mdlPaymentOrderBankInfoResponse>> {
        return await GetResponse<mdlServiceResponse<mdlPaymentOrderBankInfoResponse>>(
            "paymentOrder/getPaymentOrderBankInfo",
            pRequest
        );
    }
}

export { PaymentOrderService };